import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getOrganizationId(organizationSlug: string): Promise<string> {
    const url = this.common.constructPath(
      `/patient-previsit/organizations/slug/${organizationSlug}`,
    );
    const { organizationId } = await this.common.getJSON(url);
    return organizationId;
  }
}
